import { useState } from 'react';
import { ProjectGq } from '../../../../../graphql/projects/models/ProjectGq';
import { BooleanSchema } from 'yup';

export interface ColumnsState {
  approved: boolean;
  action: boolean;
  statusCode: boolean;
  chatGpt: boolean;
  url: boolean;
  totalVolume: boolean;
  totalTraffic: boolean;
  primary: KeywordState;
  secondary: KeywordState;
  shownTagGroupIds: number[];
  longTailKeywords: boolean;
}

export interface KeywordState {
  keyword: boolean;
  englishTranslation: boolean;
  inTitle: boolean;
  inh1: boolean;
  inContent: boolean;
  rank: boolean;
  volume: boolean;
  traffic: boolean;
}

const initialState: ColumnsState = {
  approved: true,
  action: true,
  statusCode: true,
  chatGpt: true,
  url: true,
  totalVolume: true,
  totalTraffic: false,
  shownTagGroupIds: [],
  primary: {
    keyword: true,
    englishTranslation: false,
    inTitle: false,
    inh1: false,
    inContent: false,
    rank: true,
    volume: false,
    traffic: false,
  },
  secondary: {
    keyword: true,
    englishTranslation: false,
    inTitle: false,
    inh1: false,
    inContent: false,
    rank: false,
    volume: false,
    traffic: false,
  },
  longTailKeywords: false,
};

export type VisibleColumnsBag = ReturnType<typeof useVisibleColumns>;

export const useVisibleColumns = (project: ProjectGq) => {
  const [state, setState] = useState({
    ...initialState,
    primary: { ...initialState.primary, englishTranslation: project.hasEnglishTranslation },
    secondary: { ...initialState.secondary, englishTranslation: project.hasEnglishTranslation },
  });
  return { state, setState };
};
